"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentInteractionApi = exports.ContentInteractionApiFactory = exports.ContentInteractionApiFp = exports.ContentInteractionApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ContentInteractionApi - axios parameter creator
 * @export
 */
exports.ContentInteractionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete content interaction
         * @param {string} contentInteractionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentInteraction: (contentInteractionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contentInteractionId' is not null or undefined
            common_1.assertParamExists('deleteContentInteraction', 'contentInteractionId', contentInteractionId);
            const localVarPath = `/contentInteraction/{contentInteractionId}`
                .replace(`{${"contentInteractionId"}}`, encodeURIComponent(String(contentInteractionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentInteractionApi - functional programming interface
 * @export
 */
exports.ContentInteractionApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ContentInteractionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete content interaction
         * @param {string} contentInteractionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentInteraction(contentInteractionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteContentInteraction(contentInteractionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContentInteractionApi - factory interface
 * @export
 */
exports.ContentInteractionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ContentInteractionApiFp(configuration);
    return {
        /**
         *
         * @summary Delete content interaction
         * @param {string} contentInteractionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContentInteraction(contentInteractionId, options) {
            return localVarFp.deleteContentInteraction(contentInteractionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentInteractionApi - object-oriented interface
 * @export
 * @class ContentInteractionApi
 * @extends {BaseAPI}
 */
class ContentInteractionApi extends base_1.BaseAPI {
    /**
     *
     * @summary Delete content interaction
     * @param {string} contentInteractionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentInteractionApi
     */
    deleteContentInteraction(contentInteractionId, options) {
        return exports.ContentInteractionApiFp(this.configuration).deleteContentInteraction(contentInteractionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ContentInteractionApi = ContentInteractionApi;
